import { useEffect } from 'react';

import { EMAIL_RESEND_COOLDOWN_SECONDS } from '../../../api/twoFactor/types';
import { useCountdown } from '../../../hooks/useCountdown';

import Button from '../../components/Button';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

interface CodeParEmailProps {
    indice: string;
    /** Faux si l'envoi a échoué : le bouton est tout de suite disponible. */
    envoye: boolean;
    renvoiEnCours: boolean;
    onRenvoyer: (redemarrer: () => void) => void;
}

/** Adresse masquée + « Renvoyer le code », verrouillé 60 s comme côté serveur. */
export default function CodeParEmail({ indice, envoye, renvoiEnCours, onRenvoyer }: CodeParEmailProps) {
    const { secondsLeft, start } = useCountdown();

    useEffect(() => {
        // Une seule fois au montage : le verrou initial ne dépend pas des re-rendus.
        if (envoye) start(EMAIL_RESEND_COOLDOWN_SECONDS);
    }, []);

    return (
        <>
            <Text variante="petit" ton="attenue" className="block leading-snug">
                {envoye
                    ? t('connexion.codeEnvoye', { indice })
                    : t('connexion.codeNonEnvoye', { indice })}
            </Text>
            <Button
                libelle={secondsLeft > 0 ? t('connexion.renvoyerCodeDans', { secondes: secondsLeft }) : t('connexion.renvoyerCode')}
                variante="lien"
                disabled={renvoiEnCours || secondsLeft > 0}
                onPress={() => onRenvoyer(() => start(EMAIL_RESEND_COOLDOWN_SECONDS))}
            />
        </>
    );
}
